
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-linkedin",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.344 31.187H.525V10.588h6.82v20.599zM3.847 7.796C1.574 7.796 0 6.225 0 4.305 0 2.211 1.574.814 3.847.814s3.847 1.571 3.847 3.491-1.399 3.491-3.847 3.491zM32 31.187h-6.82V20.19c0-2.793-1.049-4.713-3.497-4.713-1.924 0-2.972 1.222-3.498 2.444-.174.524-.174 1.047-.174 1.746v11.521h-6.82s.174-18.677 0-20.597h6.819v2.967c.875-1.396 2.448-3.316 6.12-3.316 4.547-.001 7.869 2.967 7.869 9.251v11.695z"}})])
          )
        }
      }
    